import React, { Suspense } from 'react';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { useAppBootstrap } from 'hooks/useAppBootstrap';
import type { RouterAppContext } from '../routerContext';

const RouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null
    : React.lazy(() =>
        import('@tanstack/react-router-devtools').then((m) => ({
          default: m.TanStackRouterDevtools,
        })),
      );

function RootComponent() {
  useAppBootstrap();

  return (
    <>
      <Outlet />
      <Suspense fallback={null}>
        <RouterDevtools />
      </Suspense>
    </>
  );
}

export const Route = createRootRouteWithContext<RouterAppContext>()({
  component: RootComponent,
});
